import { render, staticRenderFns } from "./UserBehaviour.vue?vue&type=template&id=46c345e8&scoped=true&"
import script from "./UserBehaviour.vue?vue&type=script&lang=js&"
export * from "./UserBehaviour.vue?vue&type=script&lang=js&"
import style0 from "./UserBehaviour.vue?vue&type=style&index=0&id=46c345e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c345e8",
  null
  
)

export default component.exports